module.exports = __webpack_public_path__ + "static/legends-9-9e1e31b8707e6953d91eccbf81c78841.jpg";